
<div
	class="flow-new-placeholder text-align-center"
	:compact="compact"
	:direction="direction"
	:tabindex="tabindex"
	@click="handleClick($event)"
>
	<div v-if="!onlyIcon" class="env-plus-container" @click="handlePlusClick($event)">
		<Icon name="i-plus" state="dark" :effects="false" size="x-small" />
	</div>
	<Icon v-if="onlyIcon" name="i-plus" state="dark" :effects="false" size="x-small" />
	<slot v-if="!compact" />
</div>
